import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectModal", "newTeamPopup", "newTeamFrame"]
  static values = {
    action: String,
    autoShowIfEmpty: Boolean,
  }

  connect() {
    this.onShownBound = this.onShown.bind(this)
    this.onHiddenBound = this.onHidden.bind(this)
    this.onNewTeamPopupShownBound = this.onNewTeamPopupShown.bind(this)
    if (this.hasSelectModalTarget) {
      this.selectModalTarget.addEventListener("shown.bs.modal", this.onShownBound)
      this.selectModalTarget.addEventListener("hidden.bs.modal", this.onHiddenBound)
    }
    if (this.hasNewTeamPopupTarget) {
      this.newTeamPopupTarget.addEventListener("shown.bs.modal", this.onNewTeamPopupShownBound)
    }
    if (this.autoShowIfEmptyValue) {
      this.showSelectTeamModal()
    }
  }

  disconnect() {
    if (this.hasSelectModalTarget) {
      this.selectModalTarget.removeEventListener("shown.bs.modal", this.onShownBound)
      this.selectModalTarget.removeEventListener("hidden.bs.modal", this.onHiddenBound)
    }
    if (this.hasNewTeamPopupTarget) {
      this.newTeamPopupTarget.removeEventListener("shown.bs.modal", this.onNewTeamPopupShownBound)
    }
  }

  onNewTeamPopupShown() {
    if (!this.hasNewTeamPopupTarget) return
    this.newTeamPopupTarget.style.zIndex = "17000"
    const backdrops = document.querySelectorAll(".modal-backdrop")
    const last = backdrops[backdrops.length - 1]
    if (last) last.style.zIndex = "16990"
  }

  onShown() {
    if (!this.hasSelectModalTarget) return
    this.selectModalTarget.style.zIndex = "16000"
    const backdrops = document.querySelectorAll(".modal-backdrop")
    const last = backdrops[backdrops.length - 1]
    if (last) last.style.zIndex = "15990"
  }

  onHidden() {
    if (!this.hasSelectModalTarget) return
    this.selectModalTarget.style.zIndex = ""
    const backdrops = document.querySelectorAll(".modal-backdrop")
    const last = backdrops[backdrops.length - 1]
    if (last) last.style.zIndex = ""
  }

  showSelectTeamModal() {
    if (!this.hasSelectModalTarget) return
    const modal = bootstrap.Modal.getOrCreateInstance(this.selectModalTarget)
    modal.show()
  }

  selectTeam(event) {
    event.preventDefault()
    const actionType = this.actionValue
    const teamElement = event.currentTarget
    if (!actionType) return
    const redirectPath = this.pathForAction(actionType, teamElement)
    if (!redirectPath) return
    if (this.hasSelectModalTarget) {
      const modal = bootstrap.Modal.getInstance(this.selectModalTarget)
      if (modal) modal.hide()
    }
    setTimeout(() => { window.location.href = redirectPath }, 75)
  }

  // addNewTeam(event) {
  //   event.preventDefault()
  //   const path = this.hasAddNewPathValue ? this.addNewPathValue : "/entity_admins/entity_teams"
  //   const baseUrl = path.startsWith("http") ? path : `${window.location.origin}${path.startsWith("/") ? path : `/${path}`}`
  //   const url = new URL(baseUrl, window.location.origin)
  //   url.searchParams.set("embedded", "1")
  //   const fullUrl = url.toString()
  //   if (this.hasSelectModalTarget) {
  //     const modal = bootstrap.Modal.getInstance(this.selectModalTarget)
  //     if (modal) modal.hide()
  //   }
  //   if (this.hasNewTeamPopupTarget && this.hasNewTeamFrameTarget) {
  //     this.newTeamFrameTarget.src = fullUrl
  //     const popup = bootstrap.Modal.getOrCreateInstance(this.newTeamPopupTarget)
  //     popup.show()
  //   } else {
  //     setTimeout(() => { window.location.href = fullUrl }, 75)
  //   }
  // }

  clearNewTeamFrame() {
    if (this.hasNewTeamFrameTarget) this.newTeamFrameTarget.removeAttribute("src")
  }

  pathForAction(actionType, teamElement) {
    const map = {
      team: "selectTeamModalPathTeam",
      game_recap: "selectTeamModalPathGameRecap",
      player_bio: "selectTeamModalPathPlayerBio",
      nomination: "selectTeamModalPathNomination",
      transcription: "selectTeamModalPathTranscription",
      import_schedule: "selectTeamModalPathImportSchedule",
      import_roster: "selectTeamModalPathImportRoster",
      online_interview: "selectTeamModalPathOnlineInterview",
    }
    const key = map[actionType]
    if (!key) return null
    const raw = teamElement?.dataset?.[key]
    if (!raw || raw === "#") return null
    if (raw.startsWith("http")) return raw
    return `${window.location.origin}${raw.startsWith("/") ? raw : `/${raw}`}`
  }
}
